import { render } from "./EquipPack.vue?vue&type=template&id=b97f7b62&scoped=true"
import script from "./EquipPack.vue?vue&type=script&lang=ts"
export * from "./EquipPack.vue?vue&type=script&lang=ts"

import "./EquipPack.vue?vue&type=style&index=0&id=b97f7b62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b97f7b62"

export default script